import HBIcon from "@/components/HBIcon";
import { cleanHtmlTag } from "@/utils/str";
import { useSafeState } from "ahooks";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";

export function SystemMessage({
  message,
  createTime,
  messageId,
  defaultFolded = true,
}) {
  const [folded, setFolded] = useState(defaultFolded);
  const [createBeforeDuration, setCreateBeforeDuration] = useSafeState("");
  const counter = useRef({ taskId: null });
  const [summaryContent, setSummaryContent] = useState();
  const detailRef = useRef(null);

  const getHumanDate = (date) => {
    const second = 1;
    const minute = 60 * second;
    const hour = 60 * minute;
    const day = 24 * hour;

    const duration =
      new Date().setHours(0, 0, 0, 0) -
      new Date(date * 1000).setHours(0, 0, 0, 0);
    const amount = Math.floor(duration / day);
    const humanize = ["今天", "昨天", "前天"][amount];
    return `${humanize || ""} ${new Date(date * 1000).toLocaleString()}`;
  };

  const calculateCreateBeforeDuration = useCallback(() => {
    setCreateBeforeDuration(
      <span className={styles.time}>
        {new Date(createTime * 1000).toLocaleString()}
      </span>
    );
  }, [createTime, setCreateBeforeDuration]);

  useEffect(() => {
    const s = folded
      ? cleanHtmlTag(message).slice(0, 50)
      : createBeforeDuration;
    setSummaryContent(s);
  }, [folded, messageId, createBeforeDuration, message]);

  const onFoldClick = useCallback(() => setFolded(!folded), [folded]);

  useEffect(() => {
    if (folded) return;

    counter.current.taskId = setTimeout(calculateCreateBeforeDuration, 0);

    const r = counter.current;
    return () => {
      clearTimeout(r.taskId);
    };
  }, [calculateCreateBeforeDuration, folded]);

  useEffect(() => {
    let target = detailRef.current;
    if (target) {
      let doms = target.querySelectorAll("[data-href]");
      const onClick = (e) => {
        if (e.target.getAttribute("data-href")) {
          window.open(e.target.getAttribute("data-href"));
        }
      };

      doms.forEach((el) => el.addEventListener("click", onClick));

      return () => {
        doms.forEach((el) => el.removeEventListener("click", onClick));
      };
    }
  }, [folded]);

  return (
    <div
      className={classNames(styles.systemMessage, { [styles.folded]: folded })}
      onDoubleClick={onFoldClick}
    >
      <div
        className={styles.action}
        onClick={onFoldClick}
        data-dialog-action={`点击-${folded ? "展开" : "收起"}`}
        data-gd-click="dialog_action"
        data-message-id={messageId}
      >
        {folded ? (
          <>
            <time>{getHumanDate(createTime)}</time>
            <HBIcon type={"ic_arrow_down"} />
            <span>展开</span>
          </>
        ) : (
          <>
            <time>{getHumanDate(createTime)}</time>
            <HBIcon type={"ic_arrow_down"} />
            <span>收起</span>
          </>
        )}
      </div>
      {!folded && (
        <div
          className={styles.detail}
          ref={detailRef}
          dangerouslySetInnerHTML={{ __html: message }}
          data-dialog-title={`系统消息-${messageId}`}
          data-gd-expose="dialog_expose"
          data-content-source="私信弹框"
        />
      )}
      <div className={styles.summary}>
        <div className={styles.content}>{summaryContent}</div>
        {!folded ? (
          <div className={styles.action} onClick={onFoldClick}>
            <HBIcon type={"ic_arrow_down"} />
            收起
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default function Wrap({
  message: { text, created_at, system_dm_id },
  ...rest
}) {
  return (
    <SystemMessage
      message={text}
      createTime={created_at}
      messageId={system_dm_id}
      {...rest}
    />
  );
}
